import * as React from "react";
import { useEffect } from "react";
import WishlistContext from "../services/WishlistContext";
import WishlistService from "../services/WishlistService";
import WishlistCard from "./WishlistCard";
import NotificationType from "./notification/NotificationType";
import useNotification from "./notification/useNotification";
import Logger from "../../../gulp/scripts/typescript/modules/Logger";

function Wishlist() {

	const wishlistContext = React.useContext(WishlistContext);
	const wishlistService = new WishlistService();
	const { addNotification } = useNotification();
	const [isLoading, setIsLoading] = React.useState(false);

	async function handleMoveAllToBasket() {
		setIsLoading(true);
		const wishlistItemsBeingMoved = wishlistContext.wishlist.Products;
		try {
			let moveWishlistResponse: any;
			moveWishlistResponse = await wishlistService.moveAllItemsToBasket();
			if (moveWishlistResponse._embedded) {
				wishlistService.trackMoveToBasket(wishlistItemsBeingMoved); 
				window.location.href = "/basket";
			} else if (moveWishlistResponse.Message) {
				addNotification({
					headline: moveWishlistResponse.Message,
					type: NotificationType.error
				});
				setIsLoading(false);
			}
		} catch (error) {
			Logger.trackException(error);
			addNotification({
				headline: "An unexpected error occurred. Please try again later.",
				type: NotificationType.error
			});
			setIsLoading(false);
		}
	}

	useEffect(() => {
		wishlistService.createSharableUrl(wishlistContext.wishlist.Products, { category: 'wishlist', medium: 'link', content: 'wishlist_link_share' });
	}, [wishlistContext.wishlist.Products, []]);

	return (
		<div className="c-section c-section--alt c-section--wishlist-cards">
			<div className={`c-section__inner ${isLoading ? 'is-loading' : ''}`}>
				<div className="c-grid c-grid--five-col js-product-results-list">
					{wishlistContext.wishlist.Products.map((product, index) => {
						return <WishlistCard {...product} key={product.Product.Guid} />
					})}
				</div>
			</div>
			{wishlistContext.wishlist.Products.length > 1 ?
				<div className="c-section--center c-section--padding-top">
					<button className="c-button" data-test="wishlist-move-all-to-basket" onClick={() => handleMoveAllToBasket()} >Move all to Basket</button>
				</div>
				: null}
		</div>
	);

}

export default Wishlist;
